<template>
  <el-dialog class="month-card-rule" :visible.sync="visible" :class="{ 'mobile-edit': editing && $store.getters.isMobile }" :modal="!editing" :modal-append-to-body="false" :width="$store.getters.isMobile ? mobileWidth : '480px'">
    <div slot="title" class="dialog-header-row">
      <span class="title-text">{{ $t('siteBuild.ruleDesc') }}</span>
      <i class="el-icon-close close-btn" @click="visible = false" />
    </div>
    <div class="content">
      <rich-text v-model="model.ruleText" class="subtitle" :editing="editing" />
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from "element-ui";
import RichText from "~/components/richText/index.vue";

export default {
  name: 'MonthCardRule',
  components: {
    RichText,
    [Dialog.name]: Dialog
  },
  props: {
    editing: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    mobileWidth() {
      return (this.editing && this.$store.getters.isMobile) ? '320px' : '90%'
    }
  },
  methods: {
    init() {
      this.visible = true
    }
  }
}
</script>

<style lang="less">
.month-card-rule {
  &.mobile-edit {
    .el-dialog {
      left: 10px;
    }
  }

  .el-dialog {
    border-radius: 12px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);

    &__header {
      padding: 20px 24px;
      border-bottom: 1px solid #f0f0f0;
      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #1a1a1a;
      }
      .el-dialog__headerbtn {
        display: none;
      }
    }

    &__body {
      padding: 24px;
    }
  }

  .dialog-header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .title-text {
      font-size: 18px;
      font-weight: 600;
      color: #1a1a1a;
    }

    .close-btn {
      font-size: 20px;
      color: #999;
      cursor: pointer;
      transition: color 0.2s;
      flex-shrink: 0;

      &:hover {
        color: #333;
      }
    }
  }

  .rich-text.focus-editor .ql-container.ql-snow {
    background-color: transparent;
  }
}
</style>
